import { Turnstile } from "@marsidev/react-turnstile";
import { forwardRef } from "react";

const SITE_KEY = window.location.hostname === 'triferis.sk' ? process.env.REACT_APP_TURNSTILE_SITE_KEY_PROD : process.env.REACT_APP_TURNSTILE_SITE_KEY;

export const CaptchaWidget = forwardRef(({ onVerify }, ref) => {
  return (
    <div className="captcha-container" style={{ margin: "1rem 0", maxWidth: "100%", overflow: "hidden" }}>
      <Turnstile
        ref={ref} // 2. Zmena: Priradenie ref
        siteKey={SITE_KEY}
        onSuccess={(token) => onVerify(token)}
        onError={() => onVerify(null)}
        onExpire={() => onVerify(null)}
        options={{ theme: "auto" }}
      />
    </div>
  );
});